'use strict';

var MessageView = require('components/common/views').Message;
var DashboardController = require('components/dashboard/dashboard_controller');
var i18n = require('utils/i18n');
var Log = require('utils/log');
var Tiles = require('components/dashboard/tiles/abstract_tile');
var StandardTileView = require('components/dashboard/views/standard_tile_view');

var SlideshowTile = StandardTileView.extend({
    template: require('components/dashboard/templates/slideshow'),

    regions: {
        main: '#js-slide-container',
    },

    initialize: function (options) {
        this.totalSlideCount = options.slides.length;
        this.currentSlideIdx = this.totalSlideCount - 1;
        this.setEvent(0);
        this.slides = [];
        this.filter = options.filter;
        for (var idx = 0; idx < this.totalSlideCount; idx++) {
            var slide = options.slides[idx];
            if (!Tiles.Library[slide.type]) {
                continue;
            }
            this.slides.push(Tiles.Library[slide.type](slide));
        }
    },

    onShow: function () {
        this.showNextSlide();
    },

    acknowlege: function (e) {
        this.slides[this.currentSlideIdx].acknowlege();
        this.updateFooter();
    },

    setEvent: function (number) {
        if (!isNaN(number)) {
            this.currentEventID = number;
            return number;
        }

        // eventID = -1? -> slideshow is paused, do not set a new eventID automatically
        if (this.currentEventID != -1) {
            this.currentEventID += 1;
            return this.currentEventID;
        }
    },

    play: function () {
        $('#js-play_pause>i').removeClass('fa-play').addClass('fa-pause');
        this.setEvent(0);
        this.showNextSlide();
    },

    pause: function () {
        this.setEvent(-1);
        $('#js-play_pause>i').removeClass('fa-pause').addClass('fa-play');
    },

    togglePlay: function () {
        if (this.currentEventID > -1) {
            this.pause();
        } else {
            this.play();
        }
        this.updateFooter();
    },

    // restrictToSlideIdxRange maps the given index on a valid index within the "this.slides"-array
    restrictToSlideIdxRange: function (idx) {
        return (idx + this.totalSlideCount) % this.totalSlideCount;
    },

    // returns true, if at least one slide has some data
    hasAnyData: function () {
        return _.reduce(
            this.slides,
            function (memo, tile) {
                return memo || tile.lastRequestStatus === Tiles.FETCH_STATUS.OK || tile.lastRequestStatus === undefined;
            },
            false
        );
    },

    getNextSlideIdx: function (slideNumber) {
        // returns the next slide index with the status specified in the Dashboard.json
        // (may be the same slide, if it is the only one) or -1 if none is found
        var self = this;
        function getNextSlideIdxWithStatus() {
            Log.assert(Tiles.STATUS[self.filter] != undefined);
            for (var idx = 0; idx < self.totalSlideCount; idx++) {
                var newIdx = self.restrictToSlideIdxRange(idx + self.currentSlideIdx + 1);
                if (self.slides[newIdx].getState() === Tiles.STATUS[self.filter]) {
                    return newIdx;
                }
            }
            return -1;
        }

        if (!isNaN(slideNumber)) {
            return this.restrictToSlideIdxRange(slideNumber);
        }

        var nextFilteredSlideIdx = getNextSlideIdxWithStatus();
        if (this.filter && nextFilteredSlideIdx != -1) {
            return nextFilteredSlideIdx;
        }

        return this.restrictToSlideIdxRange(this.currentSlideIdx + 1);
    },

    showNextSlide: function (slideNumber) {
        var forceShow = slideNumber != undefined;
        this.slides[this.currentSlideIdx].active = false;
        var lastSlideIdx = this.currentSlideIdx;
        this.currentSlideIdx = this.getNextSlideIdx(slideNumber);

        // update all skipped slides without showing them
        for (var idx = lastSlideIdx + 1; this.restrictToSlideIdxRange(idx) != this.currentSlideIdx; idx++) {
            var s = this.slides[this.restrictToSlideIdxRange(idx)];
            s.update(function () {});
        }

        var slide = this.slides[this.currentSlideIdx];
        slide.active = true;

        var self = this;
        slide.update(function (slide, data, status, region) {
            if (self.isDestroyed) {
                return;
            }
            if (status === Tiles.FETCH_STATUS.NO_RESULT) {
                // no slide with data? -> stop the slideshow until user reactivates it
                if (!self.hasAnyData()) {
                    self.updateFooter();
                    self.updateHeader();
                    self.showChildView(
                        region,
                        new MessageView({
                            title: i18n.TR('Keine Daten verfügbar'),
                            text: i18n.TR(
                                'Keine der konfigurierten Kacheln hat zur Zeit Daten. Die Diashow wurde deaktiviert.'
                            ),
                            action_label: i18n.TR('Aktivieren'),
                            action_cb: self.showNextSlide.bind(self),
                        })
                    );
                    return;
                }

                if (!forceShow) {
                    self.showNextSlide();
                    return;
                }
            }

            self.render();
            self.showChildView(region, slide.getView(data, status));
            self.triggerMethod('update:header', self.getHeaderConfiguration());
            self.updateFooter();
            var eventID = self.setEvent();
            setTimeout(function () {
                if (self.isDestroyed) {
                    return;
                }
                if (self.currentEventID === eventID) {
                    self.showNextSlide();
                }
            }, self.options.timeout);
        }, 'main');
    },

    showPreviousSlide: function () {
        this.showNextSlide(this.restrictToSlideIdxRange(this.currentSlideIdx - 1));
    },

    getHeaderConfiguration: function () {
        if (!this.hasAnyData()) {
            return undefined;
        }
        return {
            title: this.slides[this.currentSlideIdx].definition.title,
            link: this.slides[this.currentSlideIdx].definition.link,
            hasNoFullscreen: this.slides[this.currentSlideIdx].definition.hasNoFullscreen,
        };
    },

    getFooterConfiguration: function () {
        if (!this.hasAnyData()) {
            return undefined;
        }
        var centerButtons = [];
        var anyErrors = '';
        _.each(
            this.slides,
            function (slide, idx) {
                var cssClass = slide.active ? 'btn-white' : 'btn-secondary';
                // grey out all slides which are skipped
                cssClass +=
                    slide.lastRequestStatus != Tiles.FETCH_STATUS.OK && slide.lastRequestStatus != undefined
                        ? ' inactive'
                        : '';
                var state = slide.getState();
                if (state.length > 0 && !slide.acknowledged) {
                    cssClass += ' ' + state;
                    anyErrors += state;
                }

                centerButtons.push({
                    id: 'js-slide-' + idx,
                    icon: 'fa fa-circle',
                    disabled: false,
                    class: cssClass,
                    tooltip: slide.definition.title,
                });
            },
            this
        );

        return {
            leftButtons: [
                {
                    id: 'js-acknowlege',
                    icon: 'fa fa-check',
                    disabled: anyErrors.length === 0,
                    class: 'btn-secondary',
                },
                {
                    id: 'js-play_pause',
                    icon: this.currentEventID > -1 ? 'fa fa-pause' : 'fa fa-play',
                    disabled: false,
                    class: 'btn-secondary',
                },
                {
                    id: 'js-prev',
                    icon: 'fa fa-arrow-left',
                    disabled: false,
                    class: 'btn-secondary',
                },
                {
                    id: 'js-next',
                    icon: 'fa fa-arrow-right',
                    disabled: false,
                    class: 'btn-secondary',
                },
            ],
            centerButtons: centerButtons,
        };
    },

    handleFooterAction: function (action) {
        var actionType = action.split('-')[1];
        switch (actionType) {
            case 'acknowlege':
                this.acknowlege();
                break;
            case 'prev':
                this.showPreviousSlide();
                break;
            case 'next':
                this.showNextSlide(this.currentSlideIdx + 1);
                break;
            case 'play_pause':
                this.togglePlay();
                break;
            case 'slide':
                var slideNumber = parseInt(action.split('-')[2]);
                if (!isNaN(slideNumber)) {
                    this.showNextSlide(slideNumber);
                    this.togglePlay();
                }
                break;
            default:
                // unkown action, should not happen
                Log.assert(false);
        }
    },
});

module.exports = {
    getTileView: function (data) {
        return new SlideshowTile({
            parentRegion: this.definition.region,
            parentID: this.definition.id,
            slides: data.slides,
            header: data.header,
            timeout: this.definition.config.timeout || 15000,
            filter: this.definition.config.filter || undefined,
        });
    },

    getData: function () {
        var def = $.Deferred();
        var self = this;
        DashboardController.getTileData({
            success: function (spec) {
                var slides = [];
                _.each(spec.tiles, function (t) {
                    if (self.definition.config.tileIDs.includes(t.id)) {
                        slides.push(t);
                    }
                });
                def.resolve({ data: { slides: slides }, status: Tiles.FETCH_STATUS.OK });
            },
            fail: function () {
                def.resolve({ data: undefined, status: Tiles.FETCH_STATUS.ERROR });
            },
        });
        return def;
    },
};
